/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Sign_In_Existing_AriaInputs */

const en_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your existing account`)
};

const de_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei deinem bestehenden Konto anmelden`)
};

const fr_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter à ton compte existant`)
};

const es_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión en su cuenta existente`)
};

const it_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi al tuo account esistente`)
};

const nl_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in op je bestaande account`)
};

const pl_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się na swoje istniejące konto`)
};

const fi_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu olemassa olevalle tilillesi`)
};

const da_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind på din eksisterende konto`)
};

const sv_landing_cta_sign_in_existing_aria = /** @type {(inputs: Landing_Cta_Sign_In_Existing_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in på ditt befintliga konto`)
};

/**
* | output |
* | --- |
* | "Sign in to your existing account" |
*
* @param {Landing_Cta_Sign_In_Existing_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cta_sign_in_existing_aria = /** @type {((inputs?: Landing_Cta_Sign_In_Existing_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Sign_In_Existing_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "fr") return fr_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "es") return es_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "it") return it_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "nl") return nl_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "pl") return pl_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "fi") return fi_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "da") return da_landing_cta_sign_in_existing_aria(inputs)
	if (locale === "sv") return sv_landing_cta_sign_in_existing_aria(inputs)
	return en_landing_cta_sign_in_existing_aria(inputs)
});